export default (seasonData) => {

  const s = {}
  s.data = {
    seasons: seasonData
  }

  const init = () => {
    console.log('buildSeasonPaging', s.data);
    s.root = document.querySelector('.le-foot-btns');
    if (!s.root) {
      return;
    }

    if (s.data.seasons.length > 1) {
      buildPaging();
    }
  }

  const buildPaging = () => {
    const pagingBtnsItem = s.root.firstElementChild;
    const clonePagingBtnsItem = pagingBtnsItem.cloneNode(true);

    const currentSeasonIndex = s.data.seasons.findIndex(season => season.isCurrent);
    const isSeasonLastIndex = getIsSeasonLastIndex(currentSeasonIndex);
    const pagingForwardSeason = (() => {
      return isSeasonLastIndex
        ? s.data.seasons[currentSeasonIndex - 1]
        : s.data.seasons[currentSeasonIndex + 1];
    })();
    clonePagingBtnsItem.querySelector('.c-btn-rcorner').href = `/league/player/?year=${pagingForwardSeason.promoter_year}&season=${pagingForwardSeason.season}`;
    clonePagingBtnsItem.querySelector('.c-btn-rcorner__txt').textContent = `${isSeasonLastIndex ? '前' : '次'}のシーズンを見る`;

    s.root.insertAdjacentElement('afterbegin', clonePagingBtnsItem);
  }

  const getIsSeasonLastIndex = (seasonIndex) => {
    return seasonIndex == (s.data.seasons.length - 1);
  }

  init();
}
